import { takeEvery, put, call } from "redux-saga/effects"

import { VIEW_EXAM_TYPE, VIEW_CHAPTERS } from './actionTypes'
import { viewExamTypeSuccess, viewExamTypeFailed, viewChaptersSuccess, viewChaptersFailed } from './actions'

import { viewExamTypeApi, viewChaptersApi } from "../../helpers/api/api"

function* viewExamType({ meta }) {
    try {
        const response = yield call(viewExamTypeApi)
        yield put(viewExamTypeSuccess(response, meta))
    }
    catch(error) {
        const {message}=error.response.data
        yield put(viewExamTypeFailed(message, meta))
    }
}

function* viewChapters({ payload: details, meta }) {
    try {
        const response = yield call(viewChaptersApi, details)
        console.log(response)
        yield put(viewChaptersSuccess(response, meta))
    }
    catch(error) {
        const {message}=error.response.data
        yield put(viewChaptersFailed(message, meta))
    }
}

function* LessonScoreSaga() {
    yield takeEvery(VIEW_EXAM_TYPE, viewExamType)
    yield takeEvery(VIEW_CHAPTERS, viewChapters)
}

export default LessonScoreSaga